import React from 'react';
import PropTypes from 'prop-types';
import {
  extend, useDataModel, params, shape, string, arrayOf
} from '@thd-nucleus/data-sources';

export const useStoreSearch = ({ storeId }) => {
  const { data } = useDataModel('storeSearch', {
    variables: {
      storeSearchInput: storeId,
      pagesize: '1'
    },
    skip: !storeId,
  });

  const { stores } = data?.storeSearch || {};
  const store = stores?.[0];
  return {
    storeName: store?.name,
  };
};

useStoreSearch.propTypes = {
  storeId: PropTypes.string.isRequired,
};

useStoreSearch.dataModel = extend(
  {
    storeSearch: params({
      storeSearchInput: string().isRequired(),
      pagesize: string()
    }).shape({
      stores: arrayOf(
        shape({
          name: string(),
        })
      )
    })
  }
);
